import UUID from 'uuid'

// sets a global id once. 
// this function doesn't generate a new uuid every time its called
export default UUID.v4()



// WEBPACK FOOTER //
// ./app/util/id.js